import { render, staticRenderFns } from "./CustomTree.vue?vue&type=template&id=63b2a80c&scoped=true"
import script from "./CustomTree.vue?vue&type=script&lang=js"
export * from "./CustomTree.vue?vue&type=script&lang=js"
import style0 from "./CustomTree.vue?vue&type=style&index=0&id=63b2a80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2a80c",
  null
  
)

export default component.exports